module.exports = {
  accountType: [
    { value: "SAVING", label: "Savings Account" },
    { value: "CURRENT", label: "Current Account" },
    { value: "CASH_CREDIT", label: "Cash Credit" },
    { value: "OVER_DRAFT", label: "Over Draft" }
  ]
};
